const validateContactForm = values => {
    let errors = {}

    if (!values.name) {
        errors.name = 'Full name is required.'
    } else if (!/^[a-z ,.'-]+$/i.test(values.name)) {
        errors.name = 'Full name is invalid'
    }

    if (!values.email) {
        errors.email = 'Email address is required.'
    } else if (!/\S+@\S+\.\S+/.test(values.email)) {
        errors.email = 'Email address is invalid'
    }

    if (!values.subject) {
        errors.subject = 'subject is required.'
    } else if (values.message.length < 3) {
        errors.subject = 'subject is invalid'
    }

    if (!values.message) {
        errors.message = 'Message field is required.'
    } else if (values.message.length < 5) {
        errors.message = 'Message field is required.'
    }

    if (!values.reCaptchaChecked) {
        errors.reCaptchaChecked = 'Recaptcha requires verification. '
    }

    return errors
}

export default validateContactForm;